import axios from "axios";

export const fetchIntegrations = async () => {
    return await axios
        .get(`github/integrations`)
}